import { ApiRoutes } from '@/shared/constant/api';
import { api } from '@/shared/helpers/axios';

import {
	IReference,
	TAllReferencesResponseType,
	TReferenceRequestType,
} from '../types/reference.types';

export const referencesApi = {
	getAllReferences: () =>
		api.get(ApiRoutes.References).then((res) => (res.data as TAllReferencesResponseType).objects),
	getReferenceById: (id: number) =>
		api.get(`${ApiRoutes.References}/${id}`).then((res) => res.data as IReference),
	updateReference: ({ id, payload }: { id: number; payload: IReference }) =>
		api.put(`${ApiRoutes.References}/${id}`, {
			...payload,
		}),
	createReference: (payload: TReferenceRequestType) =>
		api.post(`${ApiRoutes.References}`, {
			...payload,
		}),
	deleteReference: (id: number) => api.delete(`${ApiRoutes.References}/${id}`),
};
